var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6939",
    "data-name": "Group 6939",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.915,
    height: 22.153,
    viewBox: "0 0 20.915 22.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 20.915,
    height: 22.153,
    fill: "#e7bf3c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 5.121,
    height: 0.85,
    transform: "translate(7.897 18.996)",
    fill: "#e7bf3c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6101",
    "data-name": "Group 6101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6100",
    "data-name": "Group 6100",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M32.181,83l.939,1.287a.509.509,0,0,0,.412.21h2.223a.509.509,0,0,0,.412-.21L37.105,83a.509.509,0,0,0,.1-.3h-5.12a.508.508,0,0,0,.1.3",
    transform: "translate(-24.186 -62.342)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M25.686,20.221a5.394,5.394,0,0,0-4.961,3.066,6.36,6.36,0,0,0,1.221,6.819,3.609,3.609,0,0,1,.586,1.73c.147.887.313,1.893,1.408,1.893h3.492c1.1,0,1.262-1.007,1.408-1.895a3.605,3.605,0,0,1,.583-1.728,6.359,6.359,0,0,0,1.224-6.818,5.394,5.394,0,0,0-4.961-3.066",
    transform: "translate(-15.229 -15.244)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M40.66,3.552a.6.6,0,0,0,.6-.6V.6a.6.6,0,0,0-1.19,0V2.957a.6.6,0,0,0,.6.6",
    transform: "translate(-30.203)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M21.292,8.3a.6.6,0,0,0,1.031-.595l-1.18-2.045a.6.6,0,1,0-1.031.595Z",
    transform: "translate(-15.102 -4.046)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M8.31,21.3,6.265,20.113a.6.6,0,0,0-.6,1.031l2.045,1.182a.6.6,0,0,0,.6-1.031",
    transform: "translate(-4.05 -15.102)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M69.387,56.563l-2.045-1.181a.6.6,0,0,0-.6,1.031l2.045,1.181a.6.6,0,1,0,.6-1.031",
    transform: "translate(-50.093 -41.689)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M3.553,40.663a.6.6,0,0,0-.595-.595H.6a.6.6,0,1,0,0,1.19H2.958a.6.6,0,0,0,.595-.6",
    transform: "translate(0 -30.205)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M73.491,40.068H71.128a.6.6,0,0,0,0,1.19h2.363a.6.6,0,1,0,0-1.19",
    transform: "translate(-53.171 -30.205)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M7.714,55.382,5.67,56.563a.6.6,0,0,0,.6,1.031L8.31,56.413a.6.6,0,0,0-.6-1.031",
    transform: "translate(-4.05 -41.689)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M67.048,22.406a.593.593,0,0,0,.3-.08l2.045-1.182a.6.6,0,1,0-.6-1.031L66.75,21.3a.6.6,0,0,0,.3,1.111",
    transform: "translate(-50.095 -15.102)",
    fill: "#e7bf3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M57.378,5.448a.6.6,0,0,0-.813.218L55.385,7.71a.6.6,0,0,0,1.031.595L57.6,6.261a.6.6,0,0,0-.218-.813",
    transform: "translate(-41.692 -4.047)",
    fill: "#e7bf3c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.c5a6e9fc0f1e0be971bf4d7d1fc48c6d.svg";
export { ForwardRef as ReactComponent };